<div style="display: inline-block;">
    <button
          appDebounceClick id="Header_PTEC-Menu Nav-Inicio"
          title="Inicio"
          [routerLink]="'/'+urlHome"
          routerLinkActive="is-active"
          class="c-nav_link color-blue-dark">
          <em class="material-icons" aria-hidden="true">home</em>
    Inicio
    </button>

    <button 
        appDebounceClick id="Header_PTEC-Menu Nav-InfoBussines"
        title="Información de Empresa"
        [routerLink]="'/'+urlBusinessInformation"
        routerLinkActive="is-active"
        class="c-nav_link color-blue-dark">
        <em class="material-icons" aria-hidden="true">work</em>
        Información de Empresa
    </button>

    <button 
        appDebounceClick id="Header_PTEC-Menu Nav-InfoWorker"
        title="Información de Trabajadores"
        [routerLink]="'/'+urlWorkersInformation"
        routerLinkActive="is-active"
        class="c-nav_link color-blue-dark">
        <em class="material-icons" aria-hidden="true">account_box</em>
    Gestión de Trabajadores
    </button>

    <button #AffilateRetreat mat-button [matMenuTriggerFor]="Nav_Affiliation_Retreat"
        appDebounceClick id="Header_PTEC-Menu Nav-Affiliation-Retreat"
        (click)="fshowMenuAffilateRetreat()"
        routerLinkActive="is-active"
        title="Afiliación y retiro"
        class="c-nav_link color-blue-dark"
        aria-expanded="false">
        <em class="material-icons" aria-hidden="true">supervisor_account</em>
      Afiliación y Retiro
    </button>
    <mat-menu #Nav_Affiliation_Retreat="matMenu" 
      aria-hidden="!showMenuAffilateRetreat"
      [hasBackdrop]="false">
      <button mat-menu-item class="item-child-menu" 
        [routerLink]="'/'+urlAffiliation"
        routerLinkActive="is-active"
        id="PTEC-Menu_Header Nav-Affiliations"
        title="Afiliaciones de trabajadores">
        <span class="title-item-menu" aria-hidden="!showMenuAffilateRetreat">Afiliación
          <em class="material-icons material-icons-position">keyboard_arrow_right</em>
        </span>
      </button>
      <button mat-menu-item class="item-child-menu" 
        [routerLink]="'/'+urlRetreat"
        routerLinkActive="is-active"
        id="PTEC-Menu_Header Nav-Retreats"
        title="Retiro de trabajadores">
        <span class="title-item-menu" aria-hidden="!showMenuAffilateRetreat">Retiros
          <em class="material-icons material-icons-position">keyboard_arrow_right</em>
        </span>
      </button>
    </mat-menu>

    <button
      #itemPQRS  
      appDebounceClick 
      id="PTEC-Menu_Header Nav-CustomerService"
      title="Servicio al cliente"
      routerLinkActive="is-active"
      class="c-nav_link color-blue-dark"
      ng-reflect-router-link="/pqrs"
      [routerLink]="['/pqrs']">
      <em class="material-icons" aria-hidden="true">where_to_vote</em>
    Servicio al Cliente
    </button>
</div>
